/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShipInfoMmsiGet200Response } from './ShipInfoMmsiGet200Response';
import {
    ShipInfoMmsiGet200ResponseFromJSON,
    ShipInfoMmsiGet200ResponseFromJSONTyped,
    ShipInfoMmsiGet200ResponseToJSON,
} from './ShipInfoMmsiGet200Response';

/**
 * Response containing ship information for multiple ships. Each record matches the format returned by /ship/info/{mmsi}.
 * @export
 * @interface ShipInfoBulkResponse
 */
export interface ShipInfoBulkResponse {
    /**
     * 
     * @type {Array<ShipInfoMmsiGet200Response>}
     * @memberof ShipInfoBulkResponse
     */
    records?: Array<ShipInfoMmsiGet200Response>;
}

/**
 * Check if a given object implements the ShipInfoBulkResponse interface.
 */
export function instanceOfShipInfoBulkResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipInfoBulkResponseFromJSON(json: any): ShipInfoBulkResponse {
    return ShipInfoBulkResponseFromJSONTyped(json, false);
}

export function ShipInfoBulkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipInfoBulkResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ShipInfoMmsiGet200ResponseFromJSON)),
    };
}

export function ShipInfoBulkResponseToJSON(value?: ShipInfoBulkResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ShipInfoMmsiGet200ResponseToJSON)),
    };
}

